import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@chilecompra/react-kit/components'
import InfoLabel from '../../components/Labels/InfoLabel'
import { Root, Wrapper, GridWrapper } from './ComparatorIntro.styles'
import { useTheme } from 'styled-components'

/**
 * The ComparatorIntro's container.
 */
const ComparatorIntro = ({ firstEntity, secondEntity }) => {
  const theme = useTheme()
  return (
    <Root margin="64px 0 0" padding="40px 0">
      <Wrapper>
        <GridWrapper container justifyContent="center">
          <GridWrapper item xs={12} md={10}>
            <Typography variant="body1" lineHeight="24px" margin="0 0 40px 0">
              A continuación podrás conocer como se diferencian los montos transados, mecanismos de compra utilizados,
              distribución de licitaciones, rubros más transados y tipos de proveedores según su tamaño de empresa entre{' '}
              <strong>{firstEntity.name}</strong> y <strong>{secondEntity.name}</strong>.
              <br />
              <br />
              Los organismos compradores estarán representados por los siguientes colores{' '}
              <strong>en cada uno de los gráficos</strong> que componen el comparador:
            </Typography>
            <InfoLabel label={firstEntity.name} color={theme.palette.charts.navyBlue} margin="0 24px 0 0" />
            <InfoLabel label={secondEntity.name} color={theme.palette.charts.darkRed} />
          </GridWrapper>
        </GridWrapper>
      </Wrapper>
    </Root>
  )
}

ComparatorIntro.propTypes = {
  firstEntity: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.number
  }),
  secondEntity: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.number
  })
}

export default ComparatorIntro
